// Corrected import statement
import Axios, { REQUEST_METHOD } from "../axios";

export async function apiUpdateUserRoleByUsername(username, role) {
  return Axios.fetch({
    url: "/admin/change-username-role",
    method: REQUEST_METHOD.POST,
    data: { username, role },
  }).catch((error) => {
    console.error("Error updating user role:", error);
    throw error;
  });
}

export function apiOfferSchedule(data) {
  return Axios.fetch({
    url: "/admin/offer-team-schedule",
    method: REQUEST_METHOD.POST,
    data,
  });
}
export async function apiFetchAcceptedCurrentMonthOnTeamSchedule() {
  try {
    return await Axios.fetch({
      url: "/admin/fetch-accepted-current-month-on-ambassador-team-schedules",
      method: REQUEST_METHOD.GET,
    });
  } catch (error) {
    console.error("Error fetching future BA schedules:", error);
    throw error;
  }
}
export function apiGetAtRiskAmbassadors() {
  return Axios.fetch({
    url: `/admin/at-risk`,
    method: REQUEST_METHOD.GET,
  });
}
export function apiGetAmbassadors() {
  return Axios.fetch({
    url: "/admin/fetch-ambassadors",
    method: REQUEST_METHOD.GET,
  });
}

export const apiRecordContractorsPaymentTransaction = (payments) =>
  Axios.fetch({
    url: "/admin/contractors-accounts-payable-transaction",
    method: REQUEST_METHOD.POST,
    data: payments,
  });

export async function apiFetchWhistleSkitBlownData({
  limit = 10,
  offsetNeedsReview = 0,
  offsetSuspended = 0,
} = {}) {
  return Axios.fetch({
    url: "/admin/fetch-whistle-blown-skit-data",
    method: REQUEST_METHOD.GET,
    params: { limit, offsetNeedsReview, offsetSuspended },
  });
}

export async function apiUpdateSkitStatus({ skitId, status }) {
  return Axios.fetch({
    url: "/admin/update-skit-status",
    method: REQUEST_METHOD.POST,
    data: { skitId, status },
  });
}

/**
 * Fetch all Accounts Payable transactions between two ISO dates.
 * @param {string} fromDate ISO date-string (inclusive)
 * @param {string} toDate   ISO date-string (inclusive)
 */
export function apiFetchAccountsPayableByPeriod(
  fromDate,
  toDate,
  offset = 0,
  limit = 10,
  userNameValueFilter
) {
  return Axios.fetch({
    url: "/admin/accounts-payable",
    method: REQUEST_METHOD.GET,
    params: { fromDate, toDate, offset, limit, userNameValueFilter },
  });
}

export function apiGetBrandAmbassadorsTopPerformers(limit = 10) {
  return Axios.fetch({
    url: "/admin/top-performers",
    method: REQUEST_METHOD.GET,
    params: { limit },
  });
}
export async function apiFetchSuspendedCommunications({
  limit = 10,
  offset = 0,
} = {}) {
  return Axios.fetch({
    url: "/admin/fetch-suspended-communications",
    method: REQUEST_METHOD.GET,
    params: { limit, offset },
  });
}
export async function apiCommunicationGoLive({ id, communicationType }) {
  return Axios.fetch({
    url: "/admin/update-communication-status",
    method: REQUEST_METHOD.POST,
    data: { id, communicationType, status: "live" },
  });
}

export function apiFetchWagesPayable(status, { limit = 10, offset = 0 } = {}) {
  return Axios.fetch({
    url: `/admin/accounts-payable`,
    method: REQUEST_METHOD.GET,
    params: { status, limit, offset },
  });
}

export function apiAdminSetMemberStatus(userId, memberStatus) {
  return Axios.fetch({
    url: `/admin/update-member-status/${userId}`,
    method: REQUEST_METHOD.PATCH,
    data: { memberStatus },
  });
}


export default {
  apiAdminSetMemberStatus,
  apiFetchWagesPayable,
  apiCommunicationGoLive,
  apiFetchSuspendedCommunications,
  apiGetBrandAmbassadorsTopPerformers,
  apiFetchAccountsPayableByPeriod,
  apiFetchWhistleSkitBlownData,
  apiUpdateSkitStatus,
  apiRecordContractorsPaymentTransaction,
  apiGetAtRiskAmbassadors,
  apiFetchAcceptedCurrentMonthOnTeamSchedule,
  apiUpdateUserRoleByUsername,
  apiOfferSchedule,
};
